export default {
    // nome app
    "SalesPaddy":"SalesPaddy",
    // tabs
    "Home":"Home",
    "Salons":"Salones",
    "Users":"Usuarios",
    "Dealers":"Dealers",
    "Digital Inventory":"Digital Inventory",
    // filtro nelle tabelle
    "Applica filtro":"Aplicar filtro",
    "filtro...":"filtro...",
    // azioni salon
    "Crea":"Crear",
    // salons: tabella e form
    "Ragione Sociale":"Razón social",
    "Insegna":"Letrero",
    "Autocomplete":"Autocompletar",
    "Indirizzo":"Dirección",
    "Città":"Ciudad",
    "Cap":"Código postal",
    "Paese":"Estado",
    "Provincia":"Área",
    "Nazione":"País",
    "Email":"Email",
    "Telefono":"Teléfono",
    "Web":"Web",
    "Attivo":"Activo",
    "Alert":"Alerta",
    "Tipo":"Tipo",
    "Latitude":"Latitud",
    "Longitude":"Longitud",
    "Latitude2":"Latitud2",
    "Longitude2":"Longitud2",
    // sezioni form
    "Dati principali":"Informaciones Principales",
    "Sede Legale":"Dirección de envío",
    "Contatto":"Contacto",
    "Dati qualitativi":"Informaciones cualitativas",
    // users: tabella e form
    "Dealer":"Dealer",
    "Codice X3":"Código de ERP",
    "Nome":"Nombre",
    "Cognome":"Apellido",
    "Lingua":"Idioma",
    "Privilegi":"Privilegios",
    // sezioni form
    "Dati Anagrafici":"Datos Anagráficos",
    //
    "Codice Dealer":"Código Dealer",
    "Inserire il codice":"Insertar código",
    "Codice Dealer non trovato":"Código dealer no encontrado",
    // mappa
    "Mappa Saloni":"Mapa salones",
    "Saloni visualizzati:":"Salones mostrados:",
    "Leads":"Leads",
    "Saloni":"Salones",
    "Tipo Visualizzazione:":"Tipo de vista:",
    "Heatmap":"Heatmap",
    "Markers":"Marcadores",
    "Scheda Lead":"Info Lead",
    "Scheda Cliente":"Info Salon",
    "Google Maps":"Google Maps",
    "Risultato ricerca:":"Resultados búsqueda:",
    "Corrispondenze trovate:":"Correspondencias:",
    "Valutazione:":"Evaluaciones:",
    "Recensioni:":"Reseñas:",
    "x":"x",
}